import { jsxs as o, jsx as i } from "react/jsx-runtime";
import { u as t } from "./styled-components.browser.esm-3eb04950.js";
const c = ({ text: e, children: n }) => /* @__PURE__ */ o(s, { children: [
  /* @__PURE__ */ i(l, { children: e }),
  /* @__PURE__ */ i(r, { children: n })
] }, e), l = t.div`
    grid-column: 1;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: start;
`, r = t.div`
    grid-column: 2;
    align-self: center;
`, s = t.div`
  display: grid;
  grid-template-columns: auto min-content;
  gap: 8px;
  font-weight: 400;
  height: 40px;
  line-height: 20px;
  align-items: center;
`;
export {
  c as default
};
//# sourceMappingURL=FormattedText.js.map
